export default "__VITE_ASSET__CzBkRgTL__"